export default [
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'adriana.molvinger@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'diego@foodforjoe.es',
  'tania@foodforjoe.es',
  'carla@foodforjoe.es',
  'marcela@foodforjoe.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
